import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import IconSearch from '@/checkout-instore-legacy/components/Commons/Icons/Search'
import Button from '@/checkout-instore-legacy/components/Commons/Elements/Button'

export default function SearchResultsFeedback({
  errors,
  loading,
  retrySearch,
}) {
  const tablet = window.innerWidth > 600

  return (
    <div className="flex flex-column absolute h-100 w-100 justify-center tc">
      {loading ? (
        <div className="center mb5 mb7-ns">
          <IconSearch
            width={tablet ? 100 : 50}
            height={tablet ? 100 : 50}
            color="#97A1AF"
          />
        </div>
      ) : null}
      {errors && errors.length ? (
        <div className="">
          <div className="lh-copy f3-ns ph5 ph7-ns">
            <span className="red">
              <FormattedMessage id="errorContinuingSearching" />
            </span>
            <div>&nbsp;</div>
          </div>
          <div className="dib mv4">
            <Button
              kind="primary"
              size="lg"
              lonely={false}
              onClick={retrySearch}
            >
              <FormattedMessage id="searchTryAgain" />
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  )
}

SearchResultsFeedback.propTypes = {
  errors: PropTypes.object,
  loading: PropTypes.bool,
  retrySearch: PropTypes.func,
}
